export const CLOUDFRONT_UPLOADS = 'https://d3kvhmcyaeni3o.cloudfront.net/'